var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',_vm._b({class:_vm.linkClass,attrs:{"href":_vm.href}},'a',
    _vm.isExternalLink
      ? {
          target: _vm.target,
          rel: 'noopener noreferrer'
        }
      : false
  ,false),[_vm._t("default"),(_vm.isExternalLink && _vm.showExternalIcon)?_c('i',{staticClass:"icon-sh-external-link c-externalLink__icon"}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }